import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "./../styles/EditProfilePage.css";
import { validateEmail, validateUsername, validateName } from "../components/RegExs";
import { APIBaseLink } from "../components/APIBaseLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditProfilePage = () => {
	const { user, login, logout } = useContext(AuthContext);
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");
	const [email, setEmail] = useState("");
	const [username, setUsername] = useState("");

	const [mfaEnabled, setMfaEnabled] = useState(false);
	const [showOtpModal, setShowOtpModal] = useState(false);
	const [otpCode, setOtpCode] = useState("");

	const [message, setMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState(false);

	const navigate = useNavigate();

	const API_BASE_LINK = APIBaseLink();

	useEffect(() => {
		const fetchUserInfo = async () => {
			const token = localStorage.getItem("token");
			if (!token) return;

			try {
				const response = await fetch(`${API_BASE_LINK}/user/getUserInfo/${user.id}`, {
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				if (response.ok) {
					const data = await response.json();
					setFirstname(data.firstName);
					setLastname(data.lastName);
					setEmail(data.Email);
					setUsername(data.Username);
					setMfaEnabled(data.mfaEnabled);
				}
			} catch (error) {
				console.error("Failed to fetch user info:", error);
			}
		};

		fetchUserInfo();
	}, [user.id]);

	const handleSave = async () => {
		const token = localStorage.getItem("token");

		if (!token || !user) {
			// toast.error("You Are Not Authenticated. Please Log In.")
			setMessage("You are not authenticated. Please log in.");
			setIsSuccess(false);
			return;
		}

		if (!validateEmail(email) || !validateName(firstname) || !validateName(lastname) || !validateUsername(username)) {
			setMessage("Please ensure all fields are properly formated.")
			setIsSuccess(false);
			return;
		}

		try {
			const response = await fetch(API_BASE_LINK + "/user/updateUser", {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
					userId: user.id,
					firstName: firstname,
					lastName: lastname,
					Email: email,
					Username: username,
				}),
			});

			const data = await response.json();

			if (response.ok) {
				const updatedUser = { ...user, firstname, lastname, email, username };
				login(updatedUser);
				toast.success("Profile Updated Successfully.");
				setIsSuccess(true);
			} else {
				toast.error("Failed To Update Profile");
				console.log(data.message || "Failed to update profile");
				setIsSuccess(false);
			}
		} catch (error) {
			toast.error("Error Updating Profile");
			setIsSuccess(false);
		}
	};

	const handleToggleMfa = async () => {
		const token = localStorage.getItem("token");

		try {
			const response = await fetch(API_BASE_LINK + "/user/toggle-mfa", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
					userID: user.id,
				}),
			});

			if (response.ok) {
				const data = await response.json();

				if (data.message === "OTP sent to email") {
					setShowOtpModal(true);
				} else if (data.message === "MFA Disabled") {
					// MFA disabled successfully
					setMfaEnabled(false);
					toast.success("MFA Disabled Successfully.");
					setIsSuccess(true);
					login({ ...user, mfaEnabled: false });
				}
			} else {
				toast.error("Failed To Toggle MFA.");
				setIsSuccess(false);
			}
		} catch (error) {
			toast.error("Error Toggling MFA.");
			console.log(error);
			setIsSuccess(false);
		}
	};

	const handleVerifyOtp = async () => {
		const token = localStorage.getItem("token");

		try {
			const response = await fetch(API_BASE_LINK + "/user/verify-mfa", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
					userID: user.id,
					otp: otpCode,
				}),
			});

			if (response.ok) {
				setMfaEnabled(true);
				setShowOtpModal(false);
				toast.success("MFA Enabled Successfully.");
				setIsSuccess(true);
				login({ ...user, mfaEnabled: true });
			} else {
				toast.error("Failed To Verify OTP.");
				setIsSuccess(false);
			}
		} catch (error) {
			toast.error("Error Verifying OTP.");
			setIsSuccess(false);
		}
	};

	const handleDelete = async () => {
		const token = localStorage.getItem("token");

		if (window.confirm("Are you sure you want to delete your account?")) {
			try {
				const response = await fetch(`${API_BASE_LINK}/user/deleteAccount/${user.id}`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
				});

				if (response.ok) {
					toast.success("Account Deleted Successfully");
					setIsSuccess(true);
					logout();
					navigate("/");
				} else {
					toast.error("Failed To Delete Account");
					setIsSuccess(false);
				}
			} catch (error) {
				toast.error("Error Deleting Account");
				setIsSuccess(false);
				console.log(error);
			}
		}
	};

	return (
		<div className="edit-profile-page">
			<h2>Edit Profile</h2>
			<form>
				<label>First Name:</label>
				<input type="text" value={firstname} onChange={(e) => setFirstname(e.target.value)} />

				<label>Last Name:</label>
				<input type="text" value={lastname} onChange={(e) => setLastname(e.target.value)} />

				<label>Email:</label>
				<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

				<label>Username:</label>
				<input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />

				{/* MFA toggle */}
				<div className="mfa-toggle">
					<button type="button" onClick={handleToggleMfa} className={mfaEnabled ? "enabled" : "disabled"}>
						{mfaEnabled ? "Disable MFA" : "Enable MFA"}
					</button>
				</div>

				<button type="button" onClick={handleSave}>
					Save Changes
				</button>

				<button type="button" onClick={() => navigate("/profile")}>
					End Changes
				</button>

				<button type="button" onClick={handleDelete}>
					Delete Account
				</button>
			</form>

			{message && <p className={isSuccess ? "success-message" : "error-message"}>{message}</p>}

			{/* OTP Modal */}
			{showOtpModal && (
				<div className="otp-modal">
					<div className="otp-modal-content">
						<h3>Enter OTP Code</h3>
						<input type="text" value={otpCode} onChange={(e) => setOtpCode(e.target.value)} />
						<div className="otp-buttons">
							<button onClick={handleVerifyOtp}>Verify</button>
							<button onClick={() => setShowOtpModal(false)}>Cancel</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default EditProfilePage;
